import React, { useState } from "react";
import { SidebarContainer, Logo, Nav, NavItem, Overlay, HamburgerMenu } from "../styles/SidebarStyle";

function Sidebar({ children }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <HamburgerMenu open={isOpen} onClick={() => setIsOpen(prev => !prev)}>
        <span />
        <span />
        <span />
      </HamburgerMenu>

      <Overlay open={isOpen} onClick={() => setIsOpen(false)} />

      <SidebarContainer open={isOpen}>
        <Nav>
          <NavItem href="/"><Logo>Studio 442</Logo></NavItem>
          <NavItem href="/architecture">Architecture</NavItem>
          <NavItem href="/furniture">Furniture</NavItem>
          <NavItem href="/art">Art</NavItem>
          <NavItem href="/shop">Shop</NavItem>
          <NavItem href="/events">Events</NavItem>
          <NavItem href="/contact">Contact</NavItem>
        </Nav>
      </SidebarContainer>
    </>
  );
}

export default Sidebar;
